import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import TwitterIcon from "@material-ui/icons/Twitter";

export const reminders = [
  {
    title: "Thank you from the bottom of our hearts",
    sub:
      "for your support of our small family business during this Christmas season!",
  },
  {
    title: "Free shipping on dreamcube orders in the philippines",
    sub: "₱10 flate rate shipping on all other PHILLIPINES orders.",
  },
  {
    title: "Current processing time:",
    sub:
      "8-12 weeks for all dreamcube orders, 3-5 business days for in-stock items. Contact us for rush orders.",
  },
];

export const icons = [<FacebookIcon />, <InstagramIcon />, <TwitterIcon />];
